var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "p-3" },
    [
      _c("b-alert", { attrs: { show: "", variant: "danger" } }, [
        _vm._v(_vm._s(_vm.$t("message.notAuthorizedToDisplayPage"))),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }